import { getLocale } from "../runtime";

const sv_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Köp fler & spara!`
};

const buymoresave = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_buymoresave(inputs)
	return "buyMoreSave";
};

export { buymoresave as "buyMoreSave" };